var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconEditProfile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 24C19.3774 24 24.75 18.6274 24.75 12C24.75 5.37258 19.3774 0 12.75 0C6.12258 0 0.75 5.37258 0.75 12C0.75 18.6274 6.12258 24 12.75 24Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 23.5C19.1013 23.5 24.25 18.3513 24.25 12C24.25 5.64873 19.1013 0.5 12.75 0.5C6.39873 0.5 1.25 5.64873 1.25 12C1.25 18.3513 6.39873 23.5 12.75 23.5Z",
    stroke: "#313131"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.93359 14.0883V16.1273H10.9726L16.9846 10.1143L14.9466 8.07626L8.93359 14.0883ZM18.5616 8.53826C18.6121 8.48798 18.6522 8.42823 18.6796 8.36241C18.7069 8.2966 18.721 8.22603 18.721 8.15476C18.721 8.08348 18.7069 8.01291 18.6796 7.9471C18.6522 7.88129 18.6121 7.82153 18.5616 7.77126L17.2896 6.49926C17.2393 6.44873 17.1796 6.40864 17.1138 6.38128C17.0479 6.35393 16.9774 6.33984 16.9061 6.33984C16.8348 6.33984 16.7643 6.35393 16.6984 6.38128C16.6326 6.40864 16.5729 6.44873 16.5226 6.49926L15.5276 7.49426L17.5666 9.53326L18.5616 8.53826Z",
    fill: "#313131"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEditProfile);
export default __webpack_public_path__ + "static/media/iconEditProfile.96c3b87c94b9e2446526985925028fa6.svg";
export { ForwardRef as ReactComponent };